module.exports = __webpack_public_path__ + "static/media/warningIcon.92d10e95.svg";